package nl.volleyplanner.web.util

import kotlinx.coroutines.yield
import org.w3c.dom.Node
import org.w3c.dom.NodeList
import org.w3c.dom.url.URLSearchParams

// TODO: If this is an inline function we could assign properties by { property = <> } instead of { it.property = <> }
fun jsObject(block: (dynamic) -> Unit) : dynamic {
    val obj = js("{}")
    block(obj)
    return obj
}

fun dynamicToMap(dynamicObj: dynamic) : Map<String, Any?> {
    if (dynamicObj == null) return emptyMap()

    val map = mutableMapOf<String, String>()
    val keys = js("Object.keys(dynamicObj)") as Array<String>
    for (key in keys) {
        val value = dynamicObj[key]
        map[key] = value?.toString() ?: "null"
    }
    return map
}

fun NodeList.forEach(block: (Node) -> Unit) {
    for (i in 0 until length) {
        block(item(i)!!)
    }
}

fun <T> NodeList.map(block: (Node) -> T) : List<T> {
    val result = mutableListOf<T>()
    for (i in 0 until length) {
        result.add(block(item(i)!!))
    }
    return result
}

fun <T> NodeList.mapIndexed(block: (Int, Node) -> T) : List<T> {
    val result = mutableListOf<T>()
    for (i in 0 until length) {
        result.add(block(i, item(i)!!))
    }
    return result
}

fun URLSearchParams.asMap(): Map<String, String> {
    val params = mutableMapOf<String, String>()
    this.asDynamic().forEach { value: String, key: String ->
        params[key] = value
    }
    return params
}
